export default "__VITE_ASSET__CPq7gsuX__"